import HasApplicantFiledTR from './HasApplicantFiledTR';
import IsBetweenJanAndMidFeb from './IsBetweenJanAndMidFeb';
import IsBetweenMidAprilMidMay from './IsBetweenMidAprilMidMay';
import IsBetweenMidFebMidApril from './IsBetweenMidFebMidApril';
import IsBetweenMidMayMidAug from './IsBetweenMidMayMidAug';
import IsBetweenMidAugMidOct from './IsBetweenMidAugMidOct';
import IsBetweenMidOctMidNov from './IsBetweenMidOctMidNov';
import IsBetweenMidNovAndDec from './IsBetweenMidNovAndDec';
import IsExpressLoan from './IsExpressLoan';
import HasApplicantFiledTRLastYear from './HasApplicantFiledTRLastYear';
import IsBusinessEstablishedMoreThan from './IsBusinessEstablishedMoreThan';
import IsForProfit from './IsForProfit';
import IsAnnualGrossRevenue from './IsAnnualGrossRevenue';
import IsExpressPlusLoan from './IsExpressPlusLoan';
import IsPropertyLeased from './IsPropertyLeased';
import IsPropertyOwnerAnotherIndividual from './IsPropertyOwnerAnotherIndividual';
import IsPropertyOwnerAnotherBusiness from './IsPropertyOwnerAnotherBusiness';
import IsHispanicOrLatino from './IsHispanicOrLatino';
import IsOtherEthnicity from './IsOtherEthnicity';
import IsAIAN from './IsAIAN';
import IsAsian from './IsAsian';
import IsBlackOrAfricanAmerican from './IsBlackOrAfricanAmerican';
import IsNHPI from './IsNHPI';
import HasOptionsAddedInSubRaceFromRace from './HasOptionsAddedInSubRaceFromRace';
import HasOtherRaceAddedForRace from './HasOtherRaceAddedForRace';
import HasApplicantNotFiledTR from './HasApplicantNotFiledTR';
import HasApplicantNotFiledTRLastYear from './HasApplicantNotFiledTRLastYear';
import IsForProfitCompanyTypeEqualTo from './IsForProfitCompanyTypeEqualTo';
import IsSystemPropertyOwnerRelatedToBorrower from './IsSystemPropertyOwnerRelatedToBorrower';
import IsOwned from './IsOwned';
import IsLoanCategoryEqualTo from './IsLoanCategoryEqualTo';
import IsCoreLoan from './IsCoreLoan';
import IsIndustryPGLoan from './IsIndustryPGLoan';
import IsPayingMortgage from './IsPayingMortgage';
import IsSystemPowerSingleOrMultipleUsersEqualTo from './IsSystemPowerSingleOrMultipleUsersEqualTo';
import IsSystemPowerCommunityOrPPALeaseEqualTo from './IsSystemPowerCommunityOrPPALeaseEqualTo';
import PrincipalIsPG from './PrincipalIsPG';
import IsPGLoan from './IsPGLoan';
import IsASAPCountEqualToZero from './IsASAPCountEqualToZero';
import RelatedPartyRelationshipEqualsTo from './RelatedPartyRelationshipEqualsTo';
import RelatedPartyTypeEqualsTo from './RelatedPartyTypeEqualsTo';
import HasOtherOutstandingLoanObligations from './HasOtherOutstandingLoanObligations';
import ListObligationsOrUploadDebtScheduleAnswerIs from './ListObligationsOrUploadDebtScheduleAnswerIs';
import PrincipalRents from './PrincipalRents';
import PrincipalOwns from './PrincipalOwns';
import IsApplicantSameAsPrincipal from './IsApplicantSameAsPrincipal';
import HasPlaidAssetReport from './HasPlaidAssetReport';
import BusinessTypeIsForProfit from './BusinessTypeIsForProfit';
import HasPgFiledTaxesYearsAgo from './HasPgFiledTaxesYearsAgo';
import IsBorrowerTypePropertyCompany from './IsBorrowerTypePropertyCompany';
import IsApplicationSolar from './IsApplicationSolar';
import RentRollOrTenantInfoAnswerIs from './RentRollOrTenantInfoAnswerIs';

export enum RulesetResult {
  HIDDEN = 0x0,
  OPTIONAL = 0x1,
  REQUIRED = 0x2,
  VISIBLE = 0x3,
}

export {
  HasApplicantFiledTR,
  IsBetweenJanAndMidFeb,
  IsBetweenMidFebMidApril,
  IsBetweenMidAprilMidMay,
  IsBetweenMidMayMidAug,
  IsBetweenMidAugMidOct,
  IsBetweenMidOctMidNov,
  IsBetweenMidNovAndDec,
  HasApplicantFiledTRLastYear,
  IsBusinessEstablishedMoreThan,
  IsForProfit,
  IsAnnualGrossRevenue,
  IsExpressLoan,
  IsExpressPlusLoan,
  IsPropertyOwnerAnotherIndividual,
  IsPropertyOwnerAnotherBusiness,
  IsPropertyLeased,
  IsHispanicOrLatino,
  IsOtherEthnicity,
  IsAIAN,
  IsAsian,
  IsBlackOrAfricanAmerican,
  IsNHPI,
  HasOptionsAddedInSubRaceFromRace,
  HasOtherRaceAddedForRace,
  HasApplicantNotFiledTR,
  HasApplicantNotFiledTRLastYear,
  IsForProfitCompanyTypeEqualTo,
  IsSystemPropertyOwnerRelatedToBorrower,
  IsOwned,
  IsLoanCategoryEqualTo,
  IsCoreLoan,
  IsIndustryPGLoan,
  IsPayingMortgage,
  IsSystemPowerSingleOrMultipleUsersEqualTo,
  IsSystemPowerCommunityOrPPALeaseEqualTo,
  PrincipalIsPG,
  IsPGLoan,
  IsASAPCountEqualToZero,
  RelatedPartyRelationshipEqualsTo,
  RelatedPartyTypeEqualsTo,
  HasOtherOutstandingLoanObligations,
  ListObligationsOrUploadDebtScheduleAnswerIs,
  PrincipalRents,
  PrincipalOwns,
  IsApplicantSameAsPrincipal,
  HasPlaidAssetReport,
  BusinessTypeIsForProfit,
  HasPgFiledTaxesYearsAgo,
  IsBorrowerTypePropertyCompany,
  IsApplicationSolar,
  RentRollOrTenantInfoAnswerIs,
};
